import gql from 'graphql-tag';

export const GET_AWARD_REQUEST_DRAFT = gql`
  query getAwardRequestDraft($id: uuid!) {
    main_doc_award_request_by_pk(id: $id) {
      id
      doc_processor_response
      cls_category_award {
        code
      }
      doc_award_cases(where: { is_deleted: { _eq: false } }) {
        id
      }
    }
  }
`;

export const UPDATE_AWARD_REQUEST_DRAFT = gql`
  mutation updateAwardRequestDraft($id: uuid!, $set: main_doc_award_request_set_input!) {
    update_main_doc_award_request(_set: $set, where: { id: { _eq: $id } }) {
      returning {
        id
      }
    }
  }
`;
